export enum SandboxLocalStorageKeys {
  isTrackingEnabled = 'isTrackingEnabled',
  selectedRequestType = 'selectedRequestType',
  selectedInboxType = 'selectedInboxType',
  useMocks = 'useMocks',
  envConfigs = 'envConfigs',
  tokens = 'tokens',
  darkMode = 'darkMode',
  mobileMode = 'mobileMode',
}
